import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {NavigationComponent} from "./navigation.component";
import {MainNavigationComponent} from "./main-navigation/main-navigation.component";
import {UserMenuItemComponent} from "./user-menu-item/user-menu-item.component";
import {RouterModule} from "@angular/router";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CRMModule} from "../crm/crm.module";
import {ActiveAdministrationUnitComponent} from "./active-administration-unit/active-administration-unit.component";
import {OrganizationModule} from "../organization/organization.module";
import {VisbosCoreModule} from "../core/visbos-core/visbos-core.module";

@NgModule({
  imports: [
    CommonModule, RouterModule, FormsModule, ReactiveFormsModule, CRMModule, OrganizationModule, VisbosCoreModule
  ],
  declarations: [NavigationComponent, MainNavigationComponent, UserMenuItemComponent, ActiveAdministrationUnitComponent],
  exports: [MainNavigationComponent]
})
export class NavigationModule {
}



// WEBPACK FOOTER //
// ./src/app/navigation/navigation.module.ts